var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInwestycje(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 14,
    viewBox: "0 0 16 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.75 13.75H1.25C1.04 13.75 0.8625 13.6775 0.7175 13.5325C0.5725 13.3875 0.5 13.21 0.5 13V7.36C0.5 7.14 0.585 6.955 0.755 6.805L3.5 4.405V1C3.5 0.79 3.5725 0.6125 3.7175 0.467501C3.8625 0.3225 4.04 0.25 4.25 0.25H14.75C14.96 0.25 15.1375 0.3225 15.2825 0.467501C15.4275 0.6125 15.5 0.79 15.5 1V13C15.5 13.21 15.4275 13.3875 15.2825 13.5325C15.1375 13.6775 14.96 13.75 14.75 13.75ZM5.75 12.25H8V7.705L5 5.095L2 7.705V12.25H4.25V9.25H5.75V12.25ZM9.5 12.25H14V1.75H5V3.34C5.19 3.34 5.355 3.405 5.495 3.535L9.245 6.805C9.415 6.955 9.5 7.14 9.5 7.36V12.25ZM11 6.25H12.5V7.75H11V6.25ZM11 9.25H12.5V10.75H11V9.25ZM11 3.25H12.5V4.75H11V3.25ZM8 3.25H9.5V4.75H8V3.25Z",
    fill: "#535353"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInwestycje);
export default __webpack_public_path__ + "static/media/Inwestycje.a1ecea61e2c0de5b6bf034433d96179b.svg";
export { ForwardRef as ReactComponent };